'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'

export const GroupCodeSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx = {},
  size = 'small'
}) => {
  const { groupCodes, fetchGroupCodes } = useLookupsStore()
  const [options, setOptions] = useState(testData || groupCodes || [])

  useEffect(() => {
    if (testData) return
    setOptions(groupCodes || [])
  }, [testData, groupCodes])

  useEffect(() => {
    if (testData || groupCodes.length) return
    fetchGroupCodes()
  }, [testData, fetchGroupCodes, groupCodes])

  return (
    <div data-testid="GroupCodeSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Group code"
        onChange={onChange}
        labelKey="description"
        valueKey="code"
        items={options}
        value={value}
        searchable
        size={size}
        name="groupCode"
      />
    </div>
  )
}

GroupCodeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string
}
